import React from 'react';
import {
  Route,
  Redirect,
  Switch,
  useRouteMatch,
} from 'react-router-dom';

import CoachToolsRoute from '../ToolsRoute';
import routes from './routes';
import { getTabPath, AnnouncementsManagerTab } from './announcementsManagerPages';

const AnnouncementsManagerRoutes = () => {
  const { path, url } = useRouteMatch();

  return (
    <Switch>
      {routes.map(({
        pageId,
        announcementsManagerPath,
        component,
      }) => (
        <CoachToolsRoute
          key={pageId}
          pageId={pageId}
          path={`${path}/${announcementsManagerPath}`}
          component={component}
        />
      ))}

      <Route exact path={`${path}`}>
        <Redirect to={{ pathname: `${url}/${getTabPath(AnnouncementsManagerTab.POSTS)}` }} />
      </Route>
    </Switch>
  );
};

export default AnnouncementsManagerRoutes;
